import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ClientViewModel } from '../../../models-views/client.view.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppCommon } from '../../../providers/app-common';

@Component({
  selector: 'app-cpd-people',
  standalone: false,
  templateUrl: './cpd-people.component.html',
  styleUrl: './cpd-people.component.scss'
})
export class CpdPeopleComponent {
 
  clientData:any
  @Input('project_client') project_client:any
  @Output() pocCreated = new EventEmitter<any>();
  editForm: FormGroup;
  editId: number | null = null;
  loggedInUser:any
  isNewPOC : boolean = false
  constructor(private vmc :ClientViewModel , private fb: FormBuilder) { 
    this.vmc.cpdPeopleComponent = this
    this.vmc.client.subscribe((data:any) => {
      this.clientData = data
      console.log(this.clientData)
    })
    this.loggedInUser = AppCommon.getloggedInObject().user
  }

  ngOnInit(): void {
    console.log(this.clientData)
    this.editForm = this.fb.group({
      poc_name: [''],
      type_name: [''],
      poc_email: [''],
      poc_linkedin: [''],
      poc_phone: [''],
      client_poc:[''],
      type:[''],
      created_by:[],
      modified_by:['']
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['project_client']) {
      console.log('Input changed:', changes['project_client'].currentValue);
      // You can react to the new value here
      console.log(this.project_client)
     this.project_client && this.vmc.getClientByID(this.project_client, 'app-cpd-people')
    }
  }


  startEdit(poc: any): void {
    if (!this.editForm) {
      console.error('Form is not initialized!');
      return;
    }
    this.editId = poc.id;
    this.editForm.patchValue({ 
      poc_name: poc.poc_name,
      type_name: poc.type_name,
      poc_email: poc.poc_email,
      poc_linkedin: poc.poc_linkedin,
      poc_phone: poc.poc_phone ,
      client_poc:poc.client_poc,
      type:poc.type_name == 'Primary' ? 1 : 2,
      created_by:this.loggedInUser.id
    });
  }

  save(id: number): void {
    if (!this.editForm.valid) return;
    const formValue = this.editForm.value;
   
    const index = this.clientData.poc_details.findIndex(p => p.id === this.editId);
    if (index !== -1) {
      this.clientData.poc_details[index] = {
        ...this.clientData.poc_details[index],
        ...formValue
      };
    }
    this.vmc.updatePOC(this.editForm.value,id,'CpdPeople')
   

  this.cancel();
    
  }

  cancel(): void {
  this.editId = null;
  this.isNewPOC = false;
  this.editForm.reset();
  this.pocCreated.emit(true)
  }

  delete(poc: any): void {
    this.clientData.poc_details = this.clientData.poc_details.filter(p => p.id !== poc.id);
    this.vmc.deletePOC(poc.id)
  }

  addPoc(){
 
  this.isNewPOC = true;
  this.editId = null;

  this.editForm.reset(); // Clear old values
 
 
  }

  saveNewPOC(): void {
    if (this.editForm.invalid) return;
  
 
    const formValue = this.editForm.value;

    if (this.isNewPOC) {
      const newPOC = {
        ...formValue,
        created_by:this.loggedInUser.id,
        type:formValue.type_name == 'Primary' ? 1 : 2,
        client_poc:this.project_client,

      };
      // this.clientData.poc_details.push(newPOC);
      this.vmc.createPOC(newPOC,'project-details')
    }
    
    
  }

  handleCancel(): void {
    this.editForm.reset();
    this.isNewPOC = false;
  }

  

  setPrimary(poc: any) {
    // console.log('Set Primary', poc);
    this.clientData.poc_details = this.clientData.poc_details.map(p => p.id === poc.id ? { ...p, type_name: 'Primary',type:1 } : { ...p, type_name: 'Secondary',type:2 }  );
    let pocData = this.clientData.poc_details.filter(p => p.id === poc.id )[0]
    this.editForm.patchValue({ 
      poc_name: pocData.poc_name,
      type_name: pocData.type_name,
      poc_email: pocData.poc_email,
      poc_linkedin: pocData.poc_linkedin,
      poc_phone: pocData.poc_phone ,
      client_poc:pocData.client_poc,
      type:poc.type_name == 'Primary' ? 1 : 2,
      created_by:this.loggedInUser.id
    });
    this.vmc.updatePOC(this.editForm.value,poc.id,'CpdPeople')
  }
  
}
